const Unlockedlock = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0002 1.66675C7.69898 1.66675 5.8335 3.53223 5.8335 5.83341V7.50008C4.45278 7.50008 3.3335 8.61937 3.3335 10.0001V15.8334C3.3335 17.2141 4.45278 18.3334 5.8335 18.3334H14.1668C15.5475 18.3334 16.6668 17.2141 16.6668 15.8334V10.0001C16.6668 8.61937 15.5475 7.50008 14.1668 7.50008H7.50016V5.83341C7.50016 4.4527 8.61945 3.33341 10.0002 3.33341C11.1639 3.33341 12.1439 4.12935 12.4215 5.2078C12.5362 5.65351 12.9905 5.92183 13.4362 5.80711C13.8819 5.69239 14.1502 5.23808 14.0355 4.79237C13.573 2.99543 11.9428 1.66675 10.0002 1.66675ZM10.0002 10.8334C10.4604 10.8334 10.8335 11.2065 10.8335 11.6667V14.1667C10.8335 14.627 10.4604 15.0001 10.0002 15.0001C9.53993 15.0001 9.16683 14.627 9.16683 14.1667V11.6667C9.16683 11.2065 9.53993 10.8334 10.0002 10.8334Z"
      fill="#225AEA"
    />
  </svg>
)
export default Unlockedlock
